/* LSL maquettes fiche produit — comportements communs (version, cadeaux, fenêtres, vidéos, simulateur). */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const eur = c => (c / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const esc = t => String(t).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- Version, quantité, option ---------- */
  const S = { v: null, qty: 1, opt: false };
  const optEl = () => $('[data-mq-opt]');
  function paint() {
    const v = S.v; if (!v) return;
    const optPrice = S.opt ? +(optEl()?.dataset.price || 0) : 0;
    const total = v.price * S.qty + optPrice;
    $$('[data-mq-price]').forEach(e => e.textContent = eur(v.price));
    $$('[data-mq-total]').forEach(e => e.textContent = eur(total));
    $$('[data-mq-x4]').forEach(e => e.textContent = eur(Math.round(v.price / 4)));
    $$('[data-mq-vname]').forEach(e => e.textContent = v.name);
    $$('[data-mq-why]').forEach(e => e.textContent = v.why);
    $$('[data-mq-qty]').forEach(e => e.textContent = S.qty);
    $$('[data-mq-variant]').forEach(b => {
      const on = b.dataset.mqVariant === v.key;
      b.setAttribute('aria-pressed', String(on));
      if (b.classList.contains('mq-cmp__pick')) b.textContent = on ? 'Ta version' : 'Choisir';
    });
    $$('[data-mq-col]').forEach(e => e.classList.toggle('is-sel', e.dataset.mqCol === v.key));
    document.documentElement.dataset.version = v.key;
  }
  function pick(key) {
    const b = $(`[data-mq-variant="${key}"][data-price]`); if (!b) return;
    S.v = { key, price: +b.dataset.price, name: b.dataset.name, why: b.dataset.why };
    paint();
  }

  /* ---------- Cadeaux ---------- */
  function giftSum(g) {
    const parts = $$('select', g).map(s => s.value);
    if (g.dataset.fixed) parts.splice(1, 0, g.dataset.fixed);
    $$('[data-mq-gift-sum]', g).forEach(x => x.textContent = parts.join(' · '));
  }

  /* ---------- Fenêtres ---------- */
  function openDlg(id, opener, anchor) {
    const d = document.getElementById(id); if (!d) return;
    d._opener = opener || null;
    if (!d.open) d.showModal();
    if (anchor) { const a = d.querySelector('#' + anchor); if (a) requestAnimationFrame(() => a.scrollIntoView({ block: 'start' })); }
    else d.scrollTop = 0;
  }
  document.addEventListener('close', e => {
    const d = e.target; if (!(d instanceof HTMLDialogElement)) return;
    if (d.id === 'mq-video') stopVideos();
    if (d._opener && d._opener.focus) d._opener.focus({ preventScroll: true });
  }, true);

  /* ---------- Vidéos : lecture volontaire, une seule à la fois ---------- */
  function stopVideos() {
    $$('.mq-player').forEach(p => { if (p.pause) p.pause(); p.remove(); });
    $$('.mq-vslot.is-playing').forEach(s => s.classList.remove('is-playing'));
  }
  function makePlayer(b) {
    let el;
    if (b.dataset.yt) {
      el = document.createElement('iframe');
      el.src = `https://www.youtube-nocookie.com/embed/${b.dataset.yt}?autoplay=1&rel=0&playsinline=1`;
      el.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      el.allowFullscreen = true; el.title = b.dataset.title || 'Vidéo';
    } else {
      el = document.createElement('video');
      el.src = b.dataset.src; el.controls = true; el.playsInline = true; el.preload = 'auto';
      el.setAttribute('playsinline', ''); if (b.dataset.poster) el.poster = b.dataset.poster;
    }
    el.className = 'mq-player';
    return el;
  }
  function play(b) {
    SIM.stop(); stopVideos();
    const el = makePlayer(b);
    const slot = b.dataset.target ? $(b.dataset.target) : null;
    if (slot) { slot.classList.add('is-playing'); slot.append(el); }
    else {
      const d = $('#mq-video'); if (!d) return;
      $('[data-mq-video-title]', d).textContent = b.dataset.title || 'Vidéo';
      $('.mq-video__frame', d).append(el);
      openDlg('mq-video', b);
    }
    if (el.tagName === 'VIDEO') { const p = el.play(); if (p) p.catch(() => {}); }
  }

  /* ---------- Galerie et agrandissement ---------- */
  let zoomList = [], zoomIdx = 0;
  function showZoom() {
    const d = $('#mq-zoom'); const it = zoomList[zoomIdx]; if (!d || !it) return;
    const img = $('img', d); img.src = it.full; img.alt = it.alt || '';
    $('figcaption', d).textContent = `${zoomIdx + 1} / ${zoomList.length}` + (it.alt ? ' · ' + it.alt : '');
  }
  function zoom(b) {
    const g = b.dataset.mqZoom || 'all';
    if (g === 'gal') {
      const th = $$('[data-mq-thumb]');
      zoomList = th.map(x => ({ full: x.dataset.zfull || x.dataset.full, alt: x.dataset.alt }));
      zoomIdx = Math.max(0, th.indexOf($('[data-mq-thumb][aria-current="true"]')));
    } else {
      zoomList = $$(`[data-mq-zoom="${g}"]`).map(x => ({ full: x.dataset.full, alt: x.dataset.alt }));
      zoomIdx = Math.max(0, zoomList.findIndex(x => x.full === b.dataset.full));
    }
    showZoom(); openDlg('mq-zoom', b);
  }
  function thumb(b) {
    const main = $('[data-mq-main]'); if (!main) return;
    const img = $('img', main);
    img.src = b.dataset.full; img.alt = b.dataset.alt || '';
    $$('[data-mq-thumb]').forEach(t => t.setAttribute('aria-current', String(t === b)));
    const c = $('[data-mq-count]', main); if (c) c.textContent = b.dataset.n;
  }

  /* ---------- Panier simulé ---------- */
  function cart(opener) {
    const v = S.v; const d = $('#mq-cart'); if (!v || !d) return;
    const title = d.dataset.title || '';
    const lines = [`<li><b>${esc(title)} · ${esc(v.name)}</b><b class="mq-amt">${eur(v.price * S.qty)}</b><span>Argent · quantité ${S.qty}</span></li>`];
    $$('[data-mq-gift]').forEach(g => lines.push(`<li><b>${esc(g.dataset.name)}</b><b class="mq-free">Offert</b><span>${esc($('[data-mq-gift-sum]', g).textContent)}</span></li>`));
    const o = optEl(); if (S.opt && o) lines.push(`<li><b>${esc(o.dataset.name)}</b><b class="mq-amt">${eur(+o.dataset.price)}</b><span>Option choisie</span></li>`);
    $('[data-mq-cart-lines]', d).innerHTML = lines.join('');
    openDlg('mq-cart', opener);
  }

  /* ---------- 6 choses, coffret ---------- */
  function six(root, i) {
    const tabs = $$('[data-mq-six]', root), n = tabs.length; i = Math.max(0, Math.min(n - 1, i));
    root.dataset.i = i;
    tabs.forEach((t, k) => t.setAttribute('aria-selected', String(k === i)));
    $$('[data-six-panel]', root).forEach((p, k) => p.hidden = k !== i);
    const c = $('[data-six-count]', root); if (c) c.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
    const pr = $('[data-mq-six-step="-1"]', root), nx = $('[data-mq-six-step="1"]', root);
    if (pr) pr.disabled = i === 0; if (nx) nx.disabled = i === n - 1;
  }
  function box(root, i) {
    $$('[data-mq-box]', root).forEach((b, k) => { const on = k === i; b.setAttribute('aria-expanded', String(on)); b.closest('.mq-box__item')?.setAttribute('aria-current', String(on)); const p = b.nextElementSibling; if (p) p.hidden = !on; });
    const imgs = $$('[data-box-img]', root); if (imgs.length) { const want = root.dataset['img' + i] || '0'; imgs.forEach(im => im.hidden = im.dataset.boxImg !== want); }
  }

  /* ---------- Clics ---------- */
  document.addEventListener('click', e => {
    const d = e.target;
    if (d instanceof HTMLDialogElement && d.classList.contains('mq-dlg')) { d.close(); return; }
    const b = d.closest('[data-mq-variant],[data-mq-step],[data-mq-open],[data-mq-close],[data-mq-gift-toggle],[data-mq-add],[data-mq-play],[data-mq-zoom],[data-mq-zoom-step],[data-mq-thumb],[data-mq-six],[data-mq-six-step],[data-mq-box],[data-mq-scroll]');
    if (!b) return;
    if (b.hasAttribute('data-mq-variant')) { pick(b.dataset.mqVariant); if (b.dataset.close != null) b.closest('dialog')?.close(); }
    else if (b.hasAttribute('data-mq-step')) { S.qty = Math.max(1, Math.min(9, S.qty + +b.dataset.mqStep)); paint(); }
    else if (b.hasAttribute('data-mq-open')) { e.preventDefault(); openDlg(b.dataset.mqOpen, b, b.dataset.anchor); }
    else if (b.hasAttribute('data-mq-close')) b.closest('dialog')?.close();
    else if (b.hasAttribute('data-mq-gift-toggle')) { const g = b.closest('[data-mq-gift]'); const p = $('.mq-gift__panel', g); const open = p.hidden; p.hidden = !open; b.setAttribute('aria-expanded', String(open)); b.textContent = open ? 'Fermer' : 'Personnaliser'; if (open) $('select', p)?.focus(); }
    else if (b.hasAttribute('data-mq-add')) cart(b);
    else if (b.hasAttribute('data-mq-play')) { e.preventDefault(); play(b); }
    else if (b.hasAttribute('data-mq-zoom')) zoom(b);
    else if (b.hasAttribute('data-mq-zoom-step')) { zoomIdx = (zoomIdx + +b.dataset.mqZoomStep + zoomList.length) % zoomList.length; showZoom(); }
    else if (b.hasAttribute('data-mq-thumb')) thumb(b);
    else if (b.hasAttribute('data-mq-six')) six(b.closest('[data-mq-six-root]'), +b.dataset.mqSix);
    else if (b.hasAttribute('data-mq-six-step')) { const r = b.closest('[data-mq-six-root]'); six(r, +r.dataset.i + +b.dataset.mqSixStep); }
    else if (b.hasAttribute('data-mq-box')) box(b.closest('[data-mq-box-root]'), +b.dataset.mqBox);
    else if (b.hasAttribute('data-mq-scroll')) { const t = $(b.dataset.mqScroll); if (t) { e.preventDefault(); t.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); } }
  });
  document.addEventListener('change', e => {
    const t = e.target;
    if (t.closest('[data-mq-gift]')) giftSum(t.closest('[data-mq-gift]'));
    if (t.matches('[data-mq-opt]')) { S.opt = t.checked; $$('[data-mq-opt]').forEach(x => x.checked = t.checked); paint(); }
  });
  document.addEventListener('keydown', e => {
    const d = $('#mq-zoom'); if (!d || !d.open) return;
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { zoomIdx = (zoomIdx + (e.key === 'ArrowRight' ? 1 : -1) + zoomList.length) % zoomList.length; showZoom(); }
  });

  /* ---------- Simulateur ---------- */
  const SIM = (() => {
    const root = $('[data-mq-sim]');
    if (!root) return { stop() {} };
    const srcs = $$('[data-sim-src]', root);
    let src = srcs[0], sound = true, on = false, fx = 0, cur = null, primed = '';
    const cache = new Map();
    const stat = $('[data-sim-status]', root);
    const say = t => { if (stat) stat.textContent = t; };
    const name = () => (src && src.dataset.p) || 'extrait';
    const audio = url => { let a = cache.get(url); if (!a) { a = new Audio(url); a.preload = 'auto'; cache.set(url, a); } return a; };
    function prime() { if (!src || primed === src.dataset.p) return; ['ignite', 'impact', 'swing', 'off'].forEach(k => audio(src.dataset[k]).load()); primed = src.dataset.p; }
    function stop() { if (cur) { cur.pause(); try { cur.currentTime = 0; } catch (_) {} cur = null; } }
    function snd(kind) {
      stop(); if (!sound || !src) return;
      const a = audio(src.dataset[kind]); a.volume = .55; cur = a;
      try { a.currentTime = 0; } catch (_) {}
      const p = a.play();
      if (p) p.catch(err => { if (err && err.name !== 'AbortError') say('Le son n’a pas pu démarrer. Sur iPhone, vérifie que le mode silencieux est désactivé.'); });
    }
    function setOn(v) {
      on = v; root.classList.toggle('is-on', v); root.classList.add('was-used');
      $$('[data-sim-power]', root).forEach(b => { b.setAttribute('aria-pressed', String(v)); const l = $('[data-sim-power-label]', b); if (l) l.textContent = v ? 'Éteindre' : (b.dataset.label || 'Allumer les sabres'); });
      $$('[data-sim-fx]', root).forEach(b => b.disabled = !v);
    }
    function clearFx() { clearTimeout(fx); root.classList.remove('is-clash', 'is-swing'); }
    function power() {
      clearFx(); prime(); const v = !on; setOn(v); snd(v ? 'ignite' : 'off');
      say(v ? `Allumés · profil ${name()}. Essaie un clash ou un Smooth Swing.` : 'Sabres éteints.');
    }
    function effect(kind) {
      if (!on) setOn(true);
      clearFx(); void root.offsetWidth;
      root.classList.add(kind === 'impact' ? 'is-clash' : 'is-swing'); snd(kind);
      say((kind === 'impact' ? 'Clash' : 'Smooth Swing') + ' · ' + name());
      fx = setTimeout(clearFx, kind === 'swing' ? 1450 : 450);
    }
    root.addEventListener('click', e => {
      const b = e.target.closest('[data-sim-power],[data-sim-fx],[data-sim-sound],[data-sim-color]'); if (!b) return;
      if (b.matches('[data-sim-power]')) { stopVideos(); power(); }
      else if (b.matches('[data-sim-fx]')) { stopVideos(); effect(b.dataset.simFx); }
      else if (b.matches('[data-sim-sound]')) {
        sound = !sound; if (!sound) stop();
        b.setAttribute('aria-pressed', String(sound)); root.classList.toggle('is-muted', !sound);
        const l = $('[data-sim-sound-label]', b); if (l) l.textContent = sound ? 'Son activé' : 'Son coupé';
        say(sound ? 'Son activé : il se lance uniquement quand tu appuies.' : 'Son coupé. Les animations restent visibles.');
      } else if (b.matches('[data-sim-color]')) {
        root.style.setProperty('--beam', b.dataset.simColor);
        $$('[data-sim-color]', root).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
        $$('[data-sim-color-name]', root).forEach(n => n.textContent = b.textContent.trim());
      }
    });
    root.addEventListener('change', e => {
      if (!e.target.matches('[data-sim-profile]')) return;
      stop(); clearFx(); src = srcs[+e.target.value] || srcs[0];
      $$('[data-sim-profile-name]', root).forEach(n => n.textContent = name());
      if (on) prime();
      say(`Profil ${name()} choisi. ${on ? 'Essaie un effet.' : 'Allume pour l’écouter.'}`);
    });
    if ('IntersectionObserver' in window) new IntersectionObserver(es => { if (!es[0].isIntersecting) { stop(); clearFx(); } }, { threshold: 0 }).observe(root);
    document.addEventListener('visibilitychange', () => { if (document.hidden) { stop(); clearFx(); } });
    setOn(false); root.classList.remove('was-used');
    return { stop, isOn: () => on };
  })();

  /* ---------- Barre d'achat collante ---------- */
  const sticky = $('[data-mq-sticky]'), anchor = $('[data-mq-cta]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(es => { const r = es[0]; sticky.classList.toggle('is-shown', !r.isIntersecting && r.boundingClientRect.top < 0); }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- Démarrage ---------- */
  const first = $('[data-mq-variant][data-price][data-default]') || $('[data-mq-variant][data-price]');
  if (first) pick(first.dataset.mqVariant);
  $$('[data-mq-gift]').forEach(giftSum);
  $$('[data-mq-six-root]').forEach(r => six(r, 0));
  $$('[data-mq-box-root]').forEach(r => box(r, 0));
  window.MQ = { S, SIM };
})();
